import React from 'react'

//------------------- Global -------------------
export const months = {  
                        1 : {key:"jan", name:"January"},
                        2 : {key:"feb", name:"February"},
                        3 : {key:"mar", name:"March"},
                        4 : {key:"apr", name:"April"},
                        5 : {key:"may", name:"May"},
                        6 : {key:"jun", name:"June"},
                        7 : {key:"jul", name:"July"},
                        8 : {key:"aug", name:"August"},
                        9 : {key:"sep", name:"September"},
                        10 : {key:"oct", name:"October"},
                        11 : {key:"nov", name:"November"},
                        12 : {key:"dec", name:"December"}
                        };

export const monthByNumber = (number) => {
    return months[number];
}

//------------------- Budget & Production -------------------
export const tblColsHistory = [{
        title: 'Year',
        dataIndex: 'year',
        width: 80,
        fixed: 'left',
    }, {
        title: 'Depth',
        dataIndex: 'depth',
        width: 80,
    }, {
        title: 'Period',
        dataIndex: 'period',
        width: 80,
    },{
        title: 'Created by',
        dataIndex: 'created_by',
        width: 120,
    }, {
        title: 'Creation Date',
        dataIndex: 'created_at',
        width: 100,
    },  
    /*
    {
        title: 'Capture Format',
        dataIndex: 'capture_format',
        width: 100,
    }, {
        title: 'Reference year',
        dataIndex: 'reference_year',
        width: 90,
    },
    */
    {    
        title: 'Actions',
        dataIndex: 'actions',
        width: 150,
        fixed: 'right',
    }];

    export const tblColsNewBudget = (budget_period,budget_depth, budget_year,budget_month=0) => {
        let childs=[];
        childs = [{
            title: budget_depth.title,
            dataIndex: budget_depth.key,
            key: budget_depth.key+"main",
            width: 200,
            fixed: 'left',
            }];


        switch(budget_period.key){
            case "year":
                childs.push({
                    title: budget_period.title,
                    dataIndex: budget_depth.key+"1",
                    key: budget_depth.key+"col1",
                    width: 120,
                    align : "center"
                  });
                
                break;
            case "month":
                
                Object.keys(months).map((key) => {
                    childs.push({
                        title: months[key].name,
                        dataIndex: budget_depth.key+key,
                        key: budget_depth.key+"col"+key,
                        width: 120,
                        align : "center"
                    });
                });

                break;
            case "day":
                let total_days = new Date(budget_year, budget_month, 0).getDate();
                for (let i = 1; i <= total_days; i++) {
                    childs.push({
                        title: months[budget_month].name +" "+ i,
                        dataIndex: budget_depth.key+budget_month+'_'+i,
                        key: budget_depth.key+"col"+budget_month+'_'+i,
                        width: 120,
                        align : "center"
                    });
                } 

                break;

        }

        return childs;
   
    }

    export const tblColsNewProduction = (production_period,production_depth, production_year,production_month=0) => {
        let childs=[];
        childs = [{
            title: production_depth.title,
            dataIndex: production_depth.key,
            key: production_depth.key+"main",
            width: 200,
            fixed: 'left',
            }];


        switch(production_period.key){
            case "year":
                childs.push({
                    title: production_period.title,
                    dataIndex: production_depth.key+"1",
                    key: production_depth.key+"col1",
                    width: 120,
                    align : "center"
                  });
                
                break;
            case "month":
                
                Object.keys(months).map((key) => {
                    childs.push({
                        title: months[key].name,
                        dataIndex: production_depth.key+key,
                        key: production_depth.key+"col"+key,
                        width: 120,
                        align : "center"
                    });
                });

                break;
            case "day":
                let total_days = new Date(production_year, production_month, 0).getDate();
                
                for (let i = 1; i <= total_days; i++) {
                    childs.push({
                        title:  months[production_month].name +" "+ i,
                        dataIndex: production_depth.key+production_month+'_'+i,
                        key: production_depth.key+"col"+production_month+'_'+i,
                        width: 140,
                        align : "center"
                    });
                } 
                
                break;

        }
        return childs;
   
    }

//------------------- Parsing Queue History -------------------
export const tblColsParsingQueueHistory = [{
    title: 'Name',
    dataIndex: 'original_name',
    width: 200,
    fixed: 'left',
}, {
    title: 'Importation Date',
    dataIndex: 'date',
    width: 100,
}, {
    title: 'Has header',
    dataIndex: 'header_included',
    width: 100,
}, {
    title: 'File Size',
    dataIndex: 'file_size',
    width: 100,
},{    
    title: 'Actions',
    dataIndex: 'actions',
    width: 100,
    fixed: 'right',
}];


// WEBPACK FOOTER //
// ./src/Setup/config/Helpers.js